export default __webpack_public_path__ + "2e672bcf9976ee4c56951ce148514f20.png";